export enum DeactivateEventPackageErrorEnum {
  UPCOMING_EVENT = 'UPCOMING_EVENT',
  REQUIRED_BY_OTHER_PACKAGE = 'REQUIRED_BY_OTHER_PACKAGE'
}
